import { render, staticRenderFns } from "./LoanIncidents.vue?vue&type=template&id=51bb78ec"
import script from "./LoanIncidents.vue?vue&type=script&lang=js"
export * from "./LoanIncidents.vue?vue&type=script&lang=js"
import style0 from "./LoanIncidents.vue?vue&type=style&index=0&id=51bb78ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports